import { FiltersConfig } from '@/types';
import { QueryTag } from '../ts';

export const QUERY_KEYS = {
  USER: [QueryTag.USER] as const,
  PROJECTS_DATA: [QueryTag.PROJECTS, QueryTag.SINGLE_PROJECT_DATA] as string[],
  PROJECTS: (workspaceId?: string, page?: number, filters?: FiltersConfig) =>
    [QueryTag.PROJECTS, { workspaceId, page, ...(filters ?? {}) }] as const,
  WORKSPACE_MEMBERS: (workspaceId?: string) =>
    [QueryTag.WORKSPACE_MEMBERS, { workspaceId }] as const,
  WORKSPACE_GROUPS: (organizationId?: string) =>
    [QueryTag.WORKSPACE_GROUPS, { organizationId }] as const,
  ORGANIZATIONS: [QueryTag.ORGANIZATIONS] as const,
  ORGANIZATION_MEMBERS: (organizationId?: string, page?: number, filters?: FiltersConfig) =>
    [QueryTag.ORGANIZATION_MEMBERS, { organizationId, page, ...(filters ?? {}) }] as const,
  THEMES: (organizationId?: string, page?: number, filters?: FiltersConfig) =>
    [QueryTag.THEMES, { organizationId, page, ...(filters ?? {}) }] as const,
  THEME: (organizationId?: string, themeId?: string | null) =>
    [QueryTag.THEME, { organizationId, themeId }] as const,
  CONVERSATIONS: (
    projectId?: string,
    filterId?: string | null,
    language?: string | null,
    conversationFilter?: string,
    page?: number,
    filters?: FiltersConfig,
  ) =>
    [
      QueryTag.CONVERSATIONS,
      { projectId, filterId, language, conversationFilter, page, ...(filters ?? {}) },
    ] as const,
  CONVERSATION: (projectId?: string, conversationId?: string) =>
    [QueryTag.CONVERSATION, { projectId, conversationId }] as const,
  QUESTION_TRANSCRIPTS: (
    filterId: string | null,
    categoryType: string | null,
    projectId?: string,
    questionId?: string,
  ) => [QueryTag.QUESTION_TRANSCRIPTS, { questionId, filterId, projectId, categoryType }] as const,
  PROJECT_FILTERS: (projectId?: string) => [QueryTag.PROJECT_FILTERS, { projectId }] as const,
  INTERVIEW_QUESTIONS: (projectId?: string, filterId?: string | null) =>
    [QueryTag.INTERVIEW_QUESTIONS, { projectId, filterId }] as const,
  INTERVIEW_QUESTION_INSIGHTS: (
    projectId?: string,
    questionId?: string,
    filterId?: string | null,
  ) => [QueryTag.INTERVIEW_QUESTION_INSIGHTS, { projectId, questionId, filterId }] as const,
  INTERVIEW_QUESTION_CATEGORIES: (
    projectId?: string,
    questionId?: string,
    filterId?: string | null,
  ) => [QueryTag.INTERVIEW_QUESTION_CATEGORIES, { projectId, questionId, filterId }] as const,
  INTERVIEW_OVERVIEW: (projectId?: string, filterId?: string | null) =>
    [QueryTag.INTERVIEW_OVERVIEW, { projectId, filterId }] as const,
  PROJECT_LANGUAGES: (projectId?: string) => [QueryTag.PROJECT_LANGUAGES, { projectId }] as const,
  AI_SEARCH_RESULTS: (projectId?: string, filterId?: string | null) =>
    [QueryTag.AI_SEARCH_RESULTS, { projectId, filterId }] as const,
  PROJECT_METADATA: (projectId?: string) => [QueryTag.PROJECT_METADATA, { projectId }] as const,
  NEW_CONVERSATIONS_COUNT: (projectId?: string, filterId?: string | null) =>
    [QueryTag.NEW_CONVERSATIONS_COUNT, { projectId, filterId }] as const,
} as const;
